import { genericConfigEnabledCheck } from './addons-config-adapter-common';
// Internal Config
// Client Config when Remote Config is disabled
export function adaptComscoreClientConfig(config) {
    return config;
}
// Server Config when Remote Config is enabled
// Client Config when Remote Config is enabled
export function adaptComscoreRemoteConfigSplit(config) {
    var requiredFields = {
        customerC2: null,
        publisherSecret: null
    };
    var isEnabled = genericConfigEnabledCheck(config, requiredFields, 'Comscore');
    if (!isEnabled) {
        return;
    }
    var clientConfig = config.clientConfig;
    return {
        enabled: isEnabled,
        config: {
            customerC2: clientConfig.customerC2,
            publisherSecret: clientConfig.publisherSecret,
            allowOfflineTransmission: clientConfig.allowOfflineTransmission
        }
    };
}

//# sourceMappingURL=comscore-config-adapter.js.map